import template from './language_phrase_component.html';

class LanguagePhraseViewModel {
	constructor(params) {
		this.params = params;

		this.myTimer = null;

		// if the translation is undefined show the token at least
		this.text = ko.observable(window.global_language_phrases[params.token] || params.token);

		// if the global phrases are not loaded yet, we need to wait
		if (Object.keys(window.global_language_phrases).length <= 0)
		{
			this.myTimer = setInterval(() => {
				this.waitingLanguagePhrasesLoaded();
			}, 1000);
		}
	}

	waitingLanguagePhrasesLoaded() {
		if (Object.keys(window.global_language_phrases).length > 0)
		{
			this.text(window.global_language_phrases[this.params.token] || this.params.token);
			clearInterval(this.myTimer);
		}
	}
}
export default {
	name: 'language_phrase',
	viewModel: LanguagePhraseViewModel,
	module_type: 'ko',
	template: template,
	template_filename: 'translation/components/language_phrase'
};
